import { ChangeEvent, useState } from "react";
import { searchCustomer } from "src/apis/customerApi";
import { useWMS1120_R01Store, defaultWMS1120_R01Filter, WMS1120_R01_TabType } from "./Store_WMS1120_R01";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import useUiuxStore from "src/store/useUiuxStore";


interface Props {
	onEnterKeyDown: () => void;
}

export const SearchSection_WMS1120_R01 = (props: Props) => {
	const { onEnterKeyDown } = props;
	const { 
		WMS1120_R01activeTab: activeTab,
		WMS1120_R01Filter, 
		setWMS1120_R01Filter 
	} = useWMS1120_R01Store();
	
	const { setCodeSearchModalProps } = useUiuxStore();
	const { compCdList ,workProcessList } = useCommonCodeStore();
	
	
	// 달력 팝업 노출 여부 상태
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	
	const custInfoHandleFoucsId = 'infoCustInput_search_WMS1120';
	
	// 거래처 코드 입력 핸들러
	const handleCustChange = (e: ChangeEvent<HTMLInputElement>) => {
		setWMS1120_R01Filter({ salesCustomCdCondition: e.target.value });
	};
	
	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'salesCustomCdCondition',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'salesCustomCdCondition',
				customNm: 'salesCustomNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			}
		},
	];
	
	const { getFieldHandlers } = useInfoFormEvents({
		editData: WMS1120_R01Filter,
		setEditData: setWMS1120_R01Filter,
		defaultData: defaultWMS1120_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS1120_R01_search'
	});
	
	// 거래처 입력창 더블클릭 시 거래처 검색 모달 오픈
	const handleCustDoubleClick = async (e: React.MouseEvent<HTMLInputElement>) => {
		e.currentTarget.blur();
		getFieldHandlers('salesCustomCdCondition').onDoubleClick(e);
	};
	
	// 생산공정 옵션 (전체 포함) - 실제로는 공정 코드를 가져와야 함
	const workProcessOptions: any[] = [
		// TODO: 실제 공정 코드 리스트를 가져와야 함
	];
	
	// UI 렌더링
	return (
		<SearchSectionForm>
				{activeTab === 'sales' ? (
					<>
						{/* 매출기준 필터 */}
						<SearchDropDownForm
							label="사업장"
							value={WMS1120_R01Filter.salesCompCdCondition}
							optionList={compCdList}
							onChangeValue={(value: string) => setWMS1120_R01Filter({ salesCompCdCondition: value })}
						/>
						
						<SearchDateRangeForm
							label="매출기간"
							visible={pickerVisible}
							setVisible={setPickerVisible}
							dateRange={WMS1120_R01Filter.salesDateRange}
							setDateRange={(dateRange) => setWMS1120_R01Filter({ salesDateRange: dateRange })}
							pickerPosition={pickerPosition}
							setPickerPosition={setPickerPosition}
							wrapperOption={{
								titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[60px] min-w-[60px]",
							}}
						/>
						
						<SearchCodeModalForm
							label="거래처"
							value={WMS1120_R01Filter.salesCustomCdCondition}
							valueLabel=""
							handleFoucsId={custInfoHandleFoucsId}
							onChange={handleCustChange}
							onDoubleClick={handleCustDoubleClick}
							onKeyDown={getFieldHandlers('salesCustomCdCondition').onEnterKeyDown}
						/>
						
						<SearchInputForm
							label="품목코드"
							value={WMS1120_R01Filter.salesItemCd}
							onChange={(e) => setWMS1120_R01Filter({ salesItemCd: e.target.value })}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									onEnterKeyDown();
								}
							}}
							initValue={() => setWMS1120_R01Filter({ salesItemCd: '' })}
						/>
					</>
				) : (
					<>
						{/* 생산기준 필터 */}
						<SearchDropDownForm
							label="사업장"
							value={WMS1120_R01Filter.productCompCdCondition}
							optionList={compCdList}
							onChangeValue={(value: string) => setWMS1120_R01Filter({ productCompCdCondition: value })}
						/>
						
						<SearchDateRangeForm
							label="생산기간"
							visible={pickerVisible}
							setVisible={setPickerVisible}
							dateRange={WMS1120_R01Filter.productDateRange}
							setDateRange={(dateRange) => setWMS1120_R01Filter({ productDateRange: dateRange })}
							pickerPosition={pickerPosition}
							setPickerPosition={setPickerPosition}
							wrapperOption={{
								titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]",
							}}
						/>
						
						<SearchDropDownForm
							label="생산공정"
							value={WMS1120_R01Filter.productWorkProcessCondition}
							optionList={workProcessList}
							onChangeValue={(value: string) => setWMS1120_R01Filter({ productWorkProcessCondition: value })}
						/>
						
						<SearchInputForm
							label="품목코드"
							value={WMS1120_R01Filter.productItemCdCondition}
							onChange={(e) => setWMS1120_R01Filter({ productItemCdCondition: e.target.value })}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									onEnterKeyDown();
								}
							}}
							initValue={() => setWMS1120_R01Filter({ productItemCdCondition: '' })}
						/>
					</>
				)}
			</SearchSectionForm>
	);
};

export default SearchSection_WMS1120_R01;

